<!-- via https://codepen.io/jh3y/pen/aQomdd -->
<template>
	<div id="counter">
		{{ num }}
	</div>
</template>

<script>

export default {

	data () {
		return {
			num: this.src
		}
	},

	props: {
		src: {
			type: Number,
			default: 100
		}
	},
	computed: {
		
	},

	methods: {
		animateValue (start, end, duration) {
			if (this.elemInView) return
		    var range = end - start
		    var current = start
		    var increment = end > start? 6 : -6
		    var stepTime = Math.abs(Math.floor(duration / range))
		    var timer = setInterval(() => {
		        if (current >= end) {
		            clearInterval(timer)
		            this.num = end
		            return
		        }

		        current += increment
		        this.num = current

		    }, stepTime)
		},

		elementInViewWatcher () {
			var elem = document.getElementById('counter')
            if (elem && (window.scrollY >= elem.offsetTop - 150)) {
            	this.animateValue(0, this.src, 3000)
            	this.elemInView = true
            }
		},

		addListener () {
            this.$nextTick(() => {
                window.addEventListener('scroll', _ => {
                    this.elementInViewWatcher()
                })
            })
        }
	},

	mounted () {
		this.addListener()
	}
}

</script>

<style scoped>


</style>
